import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: max-content;
  min-height: 22em;
`;

export const ThisCol = styled.div`
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 16em;
  height: fit-content;
  position: relative;
  overflow: hidden;
  // box-shadow: 0px 0px 20px rgba(174, 177, 200, 0.05);
  background: ${Colors.Color13};

  ${props => {
    if (props?.index == 0) {
      return `margin-left: 0em;`;
    } else {
      return `margin-left: 1em;`;
    }
  }}

  .list-header {
    padding: 0.8em;
    margin-left: 0.8em;
    margin-top: 0.4em;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;

    .titulo {
      font-size: 0.8em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 70%;
      font-weight: 800;
      color: ${Colors.Color4};
      margin-left: 1em;
    }
  }

  .list-body {
    padding: 0.8em;
    background: ${Colors.Color22};
    width: 100%;
    min-height: 5em;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ThisCard = styled(Card)`
  margin-bottom: 1.3em;
  padding: 0.8em;
  border-radius: 0.6875em;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: auto;
  position: relative;
  background: ${Colors.Color8};

  .card-header {
    width: 100%;

    .card-header-top {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .codigo {
        font-size: 0.5625em;
        color: ${Colors.Color4};
        font-weight: 700;
      }

      .data {
        color: ${Colors.Color20};
        font-size: 0.5625em;
        font-weight: 700;
      }
    }

    .titulo {
      color: ${Colors.Color4};
      font-size: 0.75em;
      font-weight: 700;
    }

    .cliente {
      color: ${Colors.Color20};
      font-size: 0.65em;
      font-weight: 600;
    }
  }

  .card-footer {
    margin-top: 1em;

    .card-footer-priori {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;

      .titulo {
        color: ${Colors.Color4};
        font-size: 0.65em;
        font-weight: 700;
      }
    }

    .responsavel {
      color: ${Colors.Color20};
      font-size: 0.65em;
      font-weight: 600;
    }
  }
`;

export const ThisCardColor = styled.span`
  background: #${props => (props?.cor ? props?.cor : Colors.Color4)};
  width: 1.905em;
  height: 0.375em;
  border-radius: 1em;
  margin-right: 0.4em;
`;
